angular.module('bribac.components.inactiveDaysModalComponent', [
    'bribac.translations'
  ])
  .component('inactiveDaysModalComponent', {
    templateUrl: 'inactive-days-modal.html',
    controller: 'InactiveDaysComponentCtrl',
    bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: "<"
    }
  })

  .controller('InactiveDaysComponentCtrl', function (
    $translate,
    $scope
  ) {

    var $ctrl = this
    var now = new Date()
    var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)

    $ctrl.datePickerOpen = {
        startDate: false,
        endDate: false
    }

    $ctrl.startDateOptions = {
        minDate: tomorrow
    }
    $ctrl.endDateOptions = {}

    $scope.$watch('$ctrl.startDate', function(newVal) {
        $ctrl.endDateOptions.minDate = newVal || tomorrow
    })

    $ctrl.toggleDatePicker = function(picker) {
        $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
    }

    $ctrl.saveInactiveDateRange = function() {
        var datesList = getDatesBetweenRange($ctrl.startDate, $ctrl.endDate)
        $ctrl.resolve.callbacks.onSaveSuccess(datesList)
        $ctrl.close()
    }

    function getDatesBetweenRange(startDate, endDate) {
        var dateArray = new Array();
        var currentDate = startDate;
        while (currentDate <= endDate) {
          dateArray.push(currentDate)
          currentDate = addDay(currentDate, 1);
        }
        return dateArray;
    }

    function addDay(date, dayTobeAdded) {
        var dat = new Date(date)
        dat.setDate(dat.getDate() + dayTobeAdded);
        return dat;
    }

});